import React from "react";
import "../scss/button.scss";

const Button = ({ children, link, id }) => {
  return (
    <a className="btn" id={id} href={link}>
      {children}
    </a>
  );
};

export default Button;
